<div #signUpForm style="display: none">
	<div class="preloader3 loader-block" *ngIf="loading">
		<div class="circ1"></div>
		<div class="circ2"></div>
		<div class="circ3"></div>
		<div class="circ4"></div>
	</div>
	<form *ngIf="!loading" role="form" class="p-10" [formGroup]="signUpRequestForm" id="changePwdForm" autocomplete="off">
		<div class="row">
			<div class="col-md-12" style="margin: 0 auto">
				<input autocomplete="false" type="text" formControlName="firstname" class="swal2-input loginInput m-t-5"
					   style="margin-top: 6px; margin-bottom: 17px;"
					   placeholder="{{'TRANS_REMOTE_SIGNUP.TRANS_FIRSTNAME' | translate }}">
				<label class="text-danger"
					   *ngIf="signUpRequestForm.controls['firstname'].hasError('required')
					   && submited"> {{'TRANS_REMOTE_SIGNUP.TRANS_REQUIRED' | translate }}</label>
				<input autocomplete="false" type="text" formControlName="lastname" class="swal2-input loginInput m-t-5"
					   style="margin-top: 6px; margin-bottom: 17px;"
					   placeholder="{{'TRANS_REMOTE_SIGNUP.TRANS_LASTNAME' | translate }}">
				<label class="text-danger"
					   *ngIf="signUpRequestForm.controls['lastname'].hasError('required')
					   && submited"> {{'TRANS_REMOTE_SIGNUP.TRANS_REQUIRED' | translate }}</label>
				<input autocomplete="false" type="text" formControlName="email" class="swal2-input loginInput m-t-5"
					   style="margin-top: 6px; margin-bottom: 17px;"
					   placeholder="{{'TRANS_REMOTE_SIGNUP.TRANS_EMAIL' | translate }}">
				<label class="text-danger"
					   *ngIf="(signUpRequestForm.controls['email'].hasError('required') || signUpRequestForm.controls['email'].hasError('email'))
					   && submited"> {{'TRANS_REMOTE_SIGNUP.TRANS_NOT_VALID_EMAIL' | translate }}</label>
				<input autocomplete="false" type="password" formControlName="password" class="swal2-input loginInput"
					   placeholder="{{'TRANS_REMOTE_SIGNUP.TRANS_PASSWORD' | translate }}" container="body" [autoClose]="false" triggers="focus"
					   [ngbPopover]="passwordValidationBody"
					   [popoverTitle]="passwordValidationTitle" placement="left">
				<div class="m-b-10 m-t-10 text-center">
					<div>{{'TRANS_REMOTE_SIGNUP.TRANS_CONNECT_WITH' | translate }}:</div>
					<app-social-login (validationOutput)="socialValidation($event)"></app-social-login>
				</div>
			</div>
		</div>
	</form>
	<div class="text-danger" *ngIf="socialRegistrationProblem">
		{{'TRANS_REMOTE_SIGNUP.TRANS_ERROR' | translate }}
	</div>
</div>
<ng-template #passwordValidationTitle><b class="validationTitle">{{'TRANS_REMOTE_SIGNUP.TRANS_PASSWORD_MUST' | translate }}</b></ng-template>
<ng-template #passwordValidationBody>
	<ul class="validationRequirements">
		<li [ngClass]="signUpRequestForm.controls['password'].hasError('required') ||
    signUpRequestForm.controls['password'].hasError('hasSmallCase') ? 'text-danger' : 'text-success'">
			<i class="zmdi zmdi-circle-o"></i>
			<i class="zmdi zmdi-check-circle"></i>
			<span>{{'TRANS_REMOTE_SIGNUP.TRANS_CONTAIN_ONE' | translate }}</span>
		</li>
		<li [ngClass]="signUpRequestForm.controls['password'].hasError('required') ||
    signUpRequestForm.controls['password'].hasError('hasCapitalCase') ? 'text-danger' : 'text-success'">
			<i class="zmdi zmdi-circle-o"></i>
			<i class="zmdi zmdi-check-circle"></i>
			<span>{{'TRANS_REMOTE_SIGNUP.TRANS_CONTAIN_UPPER' | translate }}</span>
		</li>
		<li [ngClass]="signUpRequestForm.controls['password'].hasError('required') ||
    signUpRequestForm.controls['password'].hasError('hasNumber') ? 'text-danger' : 'text-success'">
			<i class="zmdi zmdi-circle-o"></i>
			<i class="zmdi zmdi-check-circle"></i>
			<span>{{'TRANS_REMOTE_SIGNUP.TRANS_CONTAIN_DIGIT' | translate }}</span>
		</li>
		<li [ngClass]="signUpRequestForm.controls['password'].hasError('required') ||
    signUpRequestForm.controls['password'].hasError('minlength') ||
    signUpRequestForm.controls['password'].hasError('maxlength')  ? 'text-danger' : 'text-success'">
			<i class="zmdi zmdi-circle-o"></i>
			<i class="zmdi zmdi-check-circle"></i>
			<span>{{'TRANS_REMOTE_SIGNUP.TRANS_LENGTH' | translate }}</span>
		<li [ngClass]="signUpRequestForm.controls['password'].hasError('required') ||
    signUpRequestForm.controls['password'].hasError('hasSpace') ? 'text-danger' : 'text-success'">
			<i class="zmdi zmdi-circle-o"></i>
			<i class="zmdi zmdi-check-circle"></i>
			<span>{{'TRANS_REMOTE_SIGNUP.TRANS_SPACE' | translate }}</span>
		</li>
	</ul>
</ng-template>